import { sanitizeBarcode } from '@/utils/nomenclature/barcode'

export default function handleChangeBarcodeInput(
  e: React.ChangeEvent<HTMLInputElement>
) {
  e.target.value = sanitizeBarcode(e.target.value)
}
